var exports = {
  "kL": "GuildVanityURLTab.module__container___M0FXeT",
  "dc": "GuildVanityURLTab.module__spinnerContainer___M0FXeT",
  "n7": "GuildVanityURLTab.module__errorAlert___M0FXeT",
  "$e": "GuildVanityURLTab.module__warning___M0FXeT",
  "au": "GuildVanityURLTab.module__warningContent___M0FXeT",
  "QW": "GuildVanityURLTab.module__warningIcon___M0FXeT",
  "r2": "GuildVanityURLTab.module__warningBody___M0FXeT",
  "tJ": "GuildVanityURLTab.module__warningTitle___M0FXeT",
  "i4": "GuildVanityURLTab.module__warningText___M0FXeT",
  "bQ": "GuildVanityURLTab.module__formBody___M0FXeT",
  "bk": "GuildVanityURLTab.module__fieldLabel___M0FXeT",
  "bd": "GuildVanityURLTab.module__inputRow___M0FXeT",
  "zo": "GuildVanityURLTab.module__inputPrefix___M0FXeT",
  "I6": "GuildVanityURLTab.module__inputWrapper___M0FXeT",
  "BK": "GuildVanityURLTab.module__helpText___M0FXeT",
  "CI": "GuildVanityURLTab.module__usage___M0FXeT",
  "JS": "GuildVanityURLTab.module__usageValue___M0FXeT",
  "o1": "GuildVanityURLTab.module__actions___M0FXeT",
};

module.exports = exports;
